import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import type { SiteStatusDto } from '@mafia/core';
import { api } from '@/lib/api';

const POLL_MS = 15_000;

/** Заглушка: игроков пускают, только пока на сайте есть администратор. Страница сама проверяет, не открылся ли сайт. */
export function SiteClosedPage() {
  useEffect(() => {
    const timer = setInterval(() => {
      api<SiteStatusDto>('/api/site/status')
        .then(({ open }) => {
          if (open) window.location.reload();
        })
        .catch(() => {});
    }, POLL_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-4 py-10 text-center">
      <div className="text-5xl">🎩</div>
      <h1 className="mt-3 font-display text-3xl tracking-wide">Мафия</h1>
      <div className="card mt-8 w-full max-w-sm space-y-3 p-6">
        <h2 className="font-display text-xl">Сейчас закрыто</h2>
        <p className="text-sm text-zinc-400">
          Сайт открывается, когда на нём есть администратор. Страница обновится сама, как только можно будет войти.
        </p>
      </div>
      <Link to="/login" className="mt-6 text-sm text-zinc-500 hover:text-white">
        Вход для администратора
      </Link>
      <Link to="/privacy" className="mt-2 text-xs text-zinc-600 hover:text-white">
        Политика обработки персональных данных
      </Link>
    </div>
  );
}
